module.exports = __webpack_public_path__ + "packshot_deluxe_KR.jpg";